import React from 'react';
import collapse from '../../assets/collapse.svg';
import expand from '../../assets/expand.svg';
import { Icon } from '../../../../shared/components/Icon';
import './NavExpandButton.scss';
export const NavExpandButton = ({ collapsed = false, onClick, }) => {
    const iconSource = collapsed ? expand : collapse;
    const altText = collapsed ? 'collapse' : 'expand';
    return (React.createElement("button", { className: "nav-expand-button", type: "button", onClick: onClick },
        React.createElement(Icon, { source: iconSource, altText: altText })));
};
//# sourceMappingURL=NavExpandButton.js.map